<div class="paginator-container">
    @if( showButtons()) {
        <button
            (click)="onPreviousPage()"
            [disabled]="isFirstPage() || showPaginator()"
            title="{{'cs.sys.genericSearch.pageBackward' | hisUi}} {{ navigateBackwardKeys }}"
            type="submit"
            iconPos="left"
            hisImage="RESULTSET_BACKWARD"
            class="transparent">
        </button>
        @if ( !showPaginator() ) {
            {{ currentPage() }} / {{ totalPages() }}
        } @else {
            <button type="text" (click)="pop.toggle($event)" class="transparent" [title]="'genericSearch.resultIterator.resultToBig' | hisUi: MAX_ELEMENTS_TO_LOAD">
                > {{ MAX_ELEMENTS_TO_LOAD }}
            </button>
            <p-popover #pop>
                <his-heading [level]="3" [value]="'genericSearch.resultIterator.resultToBig' | hisUi: MAX_ELEMENTS_TO_LOAD" />
                <button type="button" (click)="pop.hide()">{{'common.close' | hisUi}}</button>
            </p-popover>
        }
		<button
            (click)="onNextPage()"
            [disabled]="isLastPage() || showPaginator()"
            title="{{'cs.sys.genericSearch.pageForward' | hisUi}} {{ navigateForwardKeys }}"
            type="submit"
            iconPos="left"
            hisImage="RESULTSET_FORWARD"
            class="transparent">
        </button>
    }
</div>
